// extracted by mini-css-extract-plugin
module.exports = {"section":"IhprCDMDyOnZrwvaSdE8"};